import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface DeletionRequestResponse {
  message: string;
  success: boolean;
  expires_in_minutes: number;
}

export interface DeletionConfirmResponse {
  message: string;
  success: boolean;
  goto?: string;
}

export interface CancelDeletionResponse {
  message: string;
  success: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private http = inject(HttpClient);

  /**
   * Request account deletion - sends confirmation code via email
   */
  requestDeletion(): Observable<DeletionRequestResponse> {
    return this.http.post<DeletionRequestResponse>('/account/request_deletion', {});
  }

  /**
   * Confirm account deletion with the code received via email
   */
  confirmDeletion(code: string): Observable<DeletionConfirmResponse> {
    return this.http.post<DeletionConfirmResponse>('/account/confirm_deletion', { code });
  }

  /**
   * Cancel a pending deletion request
   */
  cancelDeletion(): Observable<CancelDeletionResponse> {
    return this.http.post<CancelDeletionResponse>('/account/cancel_deletion', {});
  }
}
